var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-muted font-size-sm"},[_vm._v("\n    "+_vm._s(_vm.__('orders.states_included_list'))+"\n    "),_c('div',{staticClass:"text-uppercase"},[_vm._v("\n        "+_vm._s(_vm.orderStates.map(state => _vm.__('orders.states.' + state)).join(', '))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }